import React from 'react';
import { useSelector } from 'react-redux';
import { getLanguageCode } from '@triumph/shared';
import { currencyCodeSelector } from 'src/redux/app/selectors';

const usePrice = () => {
  const currencyCode = useSelector(currencyCodeSelector) || 'GBP';
  const languageCode = getLanguageCode().toLowerCase();
  const formatNumberOptions = {
    style: 'currency',
    currency: currencyCode,
  };

  const formatPrice = (amount = 0) => {
    const formatNumber = new Intl.NumberFormat(languageCode, formatNumberOptions);
    const priceParts = formatNumber
      .formatToParts(amount)
      .filter(part => part.type !== 'currency' && part.type !== 'literal');
    const formattedPrice = priceParts
      .map(p => {
        // eslint-disable-next-line no-nested-ternary
        p.value = p.type === 'group' ? (p.value = `.`) : p.type === 'decimal' ? (p.value = `,`) : p.value;
        return p.value;
      })
      .join('');
      const formattedChinesePrice = priceParts
      .map(p => {
        p.value =
        // eslint-disable-next-line no-nested-ternary
          p.type === 'group'
            ? (p.value = `,`)
            : p.type === 'decimal' || p.type === 'fraction'
            ? (p.value = ``)
            : p.value;
        return p.value;
      })
      .join('');
      const formattedThaiPrice = formatNumber.format(amount).replace('.00', '');
    switch (languageCode) {
      case 'nb-no':
        return `NOK ${formattedPrice}`;
      case 'sv-se':
        return `SEK ${formattedPrice}`;
      case 'da-dk':
        return `DKK ${formattedPrice}`;
      case 'fi-fi':
        return `€ ${formattedPrice}`;
      case 'en-ae':
        return `AED ${formattedPrice}`;
      case 'zh-cn':
        return `${formattedChinesePrice / 100}  元起`;
      case 'th-th':
        return formattedThaiPrice;
      default:
        return formatNumber.format(amount);
    }
  };

  return formatPrice;
};

export default usePrice;
